import React, { CSSProperties, ReactNode } from 'react';
import { Error as KendoError } from '@progress/kendo-react-labels';
import styles from './_editor-card.module.scss';

export interface EditorCardProps {
  title: string;
  /** Number of selected/entered items, shown as a badge next to the title. */
  count?: number;
  /** Controls rendered at the right edge of the header (filter box, select-all, ...). */
  actions?: ReactNode;
  /** Inline validation shown in the header in place of a footer error string. */
  errorMessage?: string;
  titleStyle?: CSSProperties;
  className?: string;
  children: ReactNode;
}

/** Bordered card with a fixed header used by the decision dialog's stipulation, reason and comment editors. */
export default function EditorCard(props: EditorCardProps) {
  return (
    <section className={`${styles.editorCard} ${props.className ?? ''}`}>
      <header className={styles.header}>
        <span className={styles.title} style={props.titleStyle}>{props.title}</span>
        {props.count !== undefined && <span className={styles.countBadge}>{props.count}</span>}
        {props.errorMessage && <KendoError className={styles.headerError}>{props.errorMessage}</KendoError>}
        <span className={styles.spacer} />
        {props.actions}
      </header>
      {props.children}
    </section>
  );
}
